<template>
  <div id="app-wrapper">
    <nav class="navbar" :class="{ 'navbar-hidden': !isNavbarVisible,
      
     }">
      <div class="navbar-container">
        <div class="navbar-logo">
          <router-link to="/">
            <img
              src="@/assets/logo2.jpg"
              alt="Nafis Diabetics Logo"
              class="logo-img"
            />
          </router-link>
        </div>

        <ul class="navbar-menu" :class="{ active: isMenuOpen }">
          <li
            class="dropdown-item"
            @mouseenter="openProductDropdown"
            @mouseleave="closeProductDropdown"
            :class="{ 'mobile-dropdown-active': isProductDropdownOpen }"
          >
            <router-link to="#product" @click.prevent="toggleProductDropdown">
              ຜະລິດຕະພັນ

              <span class="dropdown-arrow-mobile"></span>
            </router-link>

            <ul class="dropdown-menu" v-show="isProductDropdownOpen">
              <li>
                <router-link to="/products/life" @click="closeMenuAndDropdown"
                  >ປະກັນຊີວິດ<span class="dropdown-arrow-mobile"></span
                ></router-link>
              </li>

              <li>
                <router-link to="/products/health" @click="closeMenuAndDropdown"
                  >ສັນຍາເພີ່ມເຕີມ ປະກັນສຸຂະພາບ<span
                    class="dropdown-arrow-mobile"
                  ></span
                ></router-link>
              </li>

              <li>
                <router-link
                  to="/products/accident"
                  @click="closeMenuAndDropdown"
                  >ປະກັນອຸປະຕິເຫດ<span class="dropdown-arrow-mobile"></span
                ></router-link>
              </li>
            </ul>
          </li>

          <li>
            <router-link to="/news" @click="closeMenu">ຂ່າວສານ</router-link>
          </li>

          <li>
            <router-link to="/about" @click="closeMenu"
              >ກ່ຽວກັບພວກເຮົາ</router-link
            >
          </li>

          <li
            class="dropdown-item"
            @mouseenter="openCareerDropdown"
            @mouseleave="closeCareerDropdown"
            :class="{ 'mobile-dropdown-active': isCareerDropdownOpen }"
          >
            <router-link to="#career" @click.prevent="toggleCareerDropdown">
              ຮ່ວມງານກັບພວກເຮົາ

              <span class="dropdown-arrow-mobile"></span>
            </router-link>

            <ul class="dropdown-menu" v-show="isCareerDropdownOpen">
              <li>
                <router-link to="/careers/jobs" @click="closeMenuAndDropdown"
                  >ຕຳແໜ່ງງານວ່າງ<span class="dropdown-arrow-mobile"></span
                ></router-link>
              </li>

              <li>
                <router-link to="/careers/agent" @click="closeMenuAndDropdown"
                  >ສະໝັກເປັນຕົວແທນ<span class="dropdown-arrow-mobile"></span
                ></router-link>
              </li>
            </ul>
          </li>

          <li>
            <router-link to="/contact" @click="closeMenu"
              >ຕິດຕໍ່ພວກເຮົາ</router-link
            >
          </li>
        </ul>

        <button
          class="hamburger"
          :class="{ active: isMenuOpen }"
          @click="toggleMenu"
          aria-label="Toggle menu"
        >
          <span></span>

          <span></span>

          <span></span>
        </button>
      </div>
    </nav>
  </div>
</template>



<script>

export default {
  data() {
    return {
      isMenuOpen: false,
      isProductDropdownOpen: false,
      isCareerDropdownOpen: false,
      lastScrollPosition: 0,
      isNavbarVisible: true,
    };
  },
  computed: {
    // 2. เพิ่ม Computed เช็คว่าเป็นหน้า Home หรือไม่
    isHomePage() {
      return this.$route.path === '/' || this.$route.name === 'Home';
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
        // 3. อัปเดตสถานะว่าอยู่บนสุดไหม (เช่น ถ้าน้อยกว่า 50px ถือว่าอยู่บนสุด)
      this.atTop = currentScrollPosition < 50;

      // ป้องกันค่า negative เมื่อ scroll ถึงบนสุด
      if (currentScrollPosition < 0) {
        return;
      }

      // ถ้า scroll ลงมากกว่า 100px และ scroll ลง -> ซ่อน navbar
      if (
        currentScrollPosition > 100 &&
        currentScrollPosition > this.lastScrollPosition
      ) {
        this.isNavbarVisible = false;
      }
      // ถ้า scroll ขึ้น -> แสดง navbar
      else if (currentScrollPosition < this.lastScrollPosition) {
        this.isNavbarVisible = true;
      }

      this.lastScrollPosition = currentScrollPosition;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;

      document.body.style.overflow = this.isMenuOpen ? "hidden" : "";
    },

    closeMenu() {
      this.isMenuOpen = false;

      this.isProductDropdownOpen = false;

      this.isCareerDropdownOpen = false;

      document.body.style.overflow = "";
    },

    closeMenuAndDropdown() {
      this.closeMenu();
    },

    openProductDropdown() {
      if (window.innerWidth > 768) {
        this.isCareerDropdownOpen = false;

        this.isProductDropdownOpen = true;
      }
    },

    closeProductDropdown() {
      if (window.innerWidth > 768) {
        this.isProductDropdownOpen = false;
      }
    },

    toggleProductDropdown() {
      if (window.innerWidth <= 768) {
        this.isCareerDropdownOpen = false;

        this.isProductDropdownOpen = !this.isProductDropdownOpen;
      }
    },

    openCareerDropdown() {
      if (window.innerWidth > 768) {
        this.isProductDropdownOpen = false;

        this.isCareerDropdownOpen = true;
      }
    },

    closeCareerDropdown() {
      if (window.innerWidth > 768) {
        this.isCareerDropdownOpen = false;
      }
    },

    toggleCareerDropdown() {
      if (window.innerWidth <= 768) {
        this.isProductDropdownOpen = false;

        this.isCareerDropdownOpen = !this.isCareerDropdownOpen;
      }
    },
  },
};
</script>



<style scoped>
/*#app-wrapper {
  min-height: 100vh;
}*/

.navbar {
    background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: fixed;
  z-index: 1000;

  top: 0;
  left: 0; 
  right: 0;
  margin: 0 auto;

  width: 80%;
  max-width: 1200px;
  border-radius: 0 0 1rem 1rem;
  margin: 0 auto;
  font-family: "Noto Sans Lao", sans-serif;
  transition: transform 0.3s ease-in-out;

}

.navbar.navbar-hidden {
  transform: translateY(-100%);
}

.navbar-container {
  max-width: 1200px;

  margin: 0 auto; 

  padding: 24px;

  display: flex;

  justify-content: right;

  align-items: center;

  height: 60px;

  position: relative;
}

.navbar-logo {
  flex-shrink: 0;

  position: absolute;

  left: 24px;
}

.logo-img {
  height: 80px;

  width: auto;

  display: block;
}

.navbar-menu {
  display: flex;

  list-style: none;

  gap: 30px;

  margin: 0;
}

.navbar-menu li a {
  text-decoration: none;

  color: #323d47;

  font-size: 1.2rem;

  font-weight: 600;

  transition: color 0.3s ease;

  white-space: nowrap;
}

.navbar-menu li a:hover {
  border-bottom: 4px solid #ea2127;
}

.hamburger {
  display: none;

  flex-direction: column;

  justify-content: space-around;

  width: 30px;

  height: 25px;

  background: transparent;

  border: none;

  cursor: pointer;

  padding: 0;

  z-index: 1001;

  position: absolute;

  right: 24px;
}

.hamburger span {
  width: 100%;

  height: 3px;

  background-color: #ea2127;

  border-radius: 2px;

  transition: all 0.3s ease;
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(4px, -4px);
}

.demo-content {
  max-width: 1200px;

  margin: 50px auto;

  padding: 20px;

  text-align: center;
}

.demo-content h1 {
  font-size: 36px;

  color: #dc2626;

  margin-bottom: 15px;
}

.demo-content p {
  font-size: 18px;

  color: #666;
}

.dropdown-item {
  position: relative;
}

.dropdown-menu {
  position: absolute;

  top: 100%;

  left: 50%;

  transform: translateX(-50%);

  background-color: #ffffff;

  min-width: 250px;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);

  border-radius: 4px;

  padding: 10px 0;

  list-style: none;

  z-index: 1050;

  margin: 0;
}

.dropdown-menu li a {
  padding: 8px 20px;

  display: block;
 
  font-size: 18px;

  color: #323d47;

  transition: 0.2s;

  border-bottom: none !important;
}

.dropdown-menu li a:hover {
  background-color: #f5f5f5;

  color: #ea2127;
}

@media (max-width: 1024px) {
  .navbar-menu {
    gap: 14px;
  }

  .navbar-menu li a {
    font-size: 16px;
  }
}

@media (min-width: 769px) {
  .dropdown-arrow-mobile {
    display: none;
  }
}

@media (max-width: 768px) {
  /*#app-wrapper {
    padding-top: 88px; /* ความสูงของ navbar + padding */
  /*}*/

  .hamburger {
    display: flex;
  }

  .logo-img {
    height: 60px;
  }

  .navbar-container {
    height: 40px;
  }

  .navbar {
    width: 100%;
    border-radius: 0;
  }

  .navbar-menu {
    position: fixed;

    top: 88px;

    right: -100%;

    width: 80%;

    max-width: 300px;

    height: 100%;

    background-color: #ffffff;

    flex-direction: column;

    justify-content: flex-start;

    align-items: flex-start;

    padding-top: 0;

    gap: 0;

    transition: right 0.5s ease;

    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);

    z-index: 1000;
  }

  .navbar-menu.active {
    right: 0;
  }

  .navbar-menu li {
    width: 100%;

    border-bottom: 1px solid #eee;
  }

  .navbar-menu li a {
    font-size: 18px;

    padding: 15px 20px;

    width: 100%;

    display: flex;

    justify-content: flex-start;

    align-items: center;

    border-bottom: none !important;
  }

  .dropdown-item > a {
    justify-content: space-between;

    padding-right: 20px;
  }

  .dropdown-menu {
    position: relative;

    top: 0;

    left: 0;

    transform: none;

    width: 100%;

    padding: 0;

    border-radius: 0;

    box-shadow: none;

    background-color: #ffffff;

    border-top: 1px solid #ddd;
  }

  .dropdown-menu li a {
    padding: 10px 40px;
    font-size: 16px;
    justify-content: flex-start;
  }

  .dropdown-arrow-mobile {
    display: inline-block;
    text-align: right;
    flex-shrink: 0;
    margin-left: 20px;
  }

  .dropdown-arrow-mobile::after {
    content: "";
    border-bottom: 2px solid #323d47;
    border-right: 2px solid #323d47;
    width: 10px;
    height: 10px;
    transform: rotate(-45deg); /* ทำเป็นรูปลูกศรชี้ลง */
    transition: transform 0.3s ease-in-out;
    display: inline-block;
  }
 
  .dropdown-item.mobile-dropdown-active > a > .dropdown-arrow-mobile::after {
    transform: rotate(45deg);
  }
}

@media (max-width: 480px) {
  .navbar-container {
    padding: 0 15px;

    height: 60px;
  }

  .logo-img {
    height: 40px;
  }

  .navbar-menu {
    width: 80%;

    max-width: none;

    top: 60px;
  }
}

@media (min-width: 1440px) {
  .navbar-container {
    max-width: 1400px;
  }

  .navbar-menu {
    gap: 40px;
  }

  .navbar-menu li a {
    font-size: 17px;
  }
}
</style>